import { defineStore } from 'pinia';
import { getItem, setItem } from '@/utils/storage';

export const useDarkModeStore = defineStore('darkMode', {
  state: () => ({
    isDark: false,
  }),

  actions: {
    init() {
      // Initialize from localStorage
      this.isDark = getItem('darkMode') === 'true';
      this.applyTheme();
    },

    toggle() {
      this.isDark = !this.isDark;
      setItem('darkMode', String(this.isDark));
      this.applyTheme();
    },

    setDarkMode(value) {
      this.isDark = value;
      setItem('darkMode', String(this.isDark));
      this.applyTheme();
    },

    applyTheme() {
      document.documentElement.classList.toggle('dark', this.isDark);
    },
  },
});
